(function() {

  // ─── Farb-Logik ────────────────────────────────────────────────────────────
  var root = document.documentElement;
  var url  = window.location.href.toLowerCase();
  var colors = {
    test:      "#8800ff",
    afterwork: "#2E4A1C",
    techno:    "#0D4075",
    rnb:       "#A82117",
    brunch:    "#FF7538"
  };
  Object.keys(colors).some(function(key){
    if (url.indexOf(key) !== -1) {
      root.style.setProperty('--collection-button-bg-color', colors[key]);
      return true;
    }
  }) || root.style.setProperty('--collection-button-bg-color', 'var(--color-text)');

  // ─── Suchfeld einfügen ──────────────────────────────────────────────────
  function addSearchField() {
    var dialog = document.getElementById("filter-dialog-filter.p.m.custom.stadt");
    if (!dialog) return;
    if (dialog.querySelector("#filter-search")) return;
    var input = document.createElement("input");
    input.id = "filter-search";
    input.type = "text";
    input.placeholder = "Stadt eingeben, z.B. Stuttgart";
    input.style.marginBottom = "1rem";
    input.autocomplete = "off";
    dialog.insertAdjacentElement("afterbegin", input);
    ["blur","change","focus","focusout"].forEach(function(evt){
      input.addEventListener(evt, function(e){ e.stopPropagation(); });
    });
    input.addEventListener("input", filterLabels);
  }

  // ─── Labels filtern ────────────────────────────────────────────────────────
  function filterLabels() {
    var q = document.getElementById("filter-search");
    if (!q) return;
    var term = q.value.toLowerCase().trim();
    var dialog = document.getElementById("filter-dialog-filter.p.m.custom.stadt");
    if (!dialog) return;
    dialog.querySelectorAll("label.facet-dialog-option").forEach(function(label){
      var txt = label.textContent.toLowerCase();
      var cb  = document.getElementById(label.getAttribute("for"));
      if (txt.indexOf(term) === 0) {
        label.style.display = "";
        if (cb) cb.style.display = "";
      } else {
        label.style.display = "none";
        if (cb) cb.style.display = "none";
      }
    });
  }

  // ─── Active-Klasse setzen ──────────────────────────────────────────────────
  function highlightActiveFilters() {
    var dialog = document.getElementById("filter-dialog-filter.p.m.custom.stadt");
    if (!dialog) return;
    dialog.querySelectorAll("label.facet-dialog-option.active").forEach(function(l){
      l.classList.remove("active");
    });
    dialog.querySelectorAll("input[type='checkbox']:checked").forEach(function(cb){
      var lab = dialog.querySelector("label.facet-dialog-option[for='" + cb.id + "']");
      if (lab) lab.classList.add("active");
    });
  }

  // ─── Klick-Handler binden ──────────────────────────────────────────────────
  function onFacetClick() {
    setTimeout(function(){
      highlightActiveFilters();
      bindClickHandlers();
    }, 300);
  }
  function bindClickHandlers() {
    var dialog = document.getElementById("filter-dialog-filter.p.m.custom.stadt");
    if (!dialog) return;
    dialog.querySelectorAll("label.facet-dialog-option").forEach(function(label){
      label.removeEventListener("click", onFacetClick);
      label.addEventListener("click", onFacetClick);
    });
  }

  // ─── Komplettes Update ────────────────────────────────────────────────────
  function refreshFacets() {
    addSearchField();
    highlightActiveFilters();
    bindClickHandlers();
  }

  // ─── Newsletter-Formular klassifizieren (poll until loaded) ───────────────
  function addNewsletterClass() {
    var form = document.querySelector('form[id*="omnisend-form"][id*="submit-form"]');
    if (form) {
      form.classList.add('newsletter-formular');
    } else {
      setTimeout(addNewsletterClass, 1000);
    }
  }

  document.addEventListener("DOMContentLoaded", function(){
    // Facet-Logik initialisieren
    refreshFacets();
    setInterval(refreshFacets, 500);

    // Produkt-Titel umbauen
    var titleEl = document.querySelector(".product-info__title");
    if (titleEl) {
      var text = titleEl.textContent.trim();
      var parts = text.split(" - ").map(function(part) {
        return part.trim();
      });
      var html = parts.map(function(part) {
        return part.replace(/\(([^)]+)\)/g, function(_, inner) {
          return '<span style="font-size:18px;font-weight:normal;text-transform:none;">(' + inner + ')</span>';
        });
      }).join("<br>");
      titleEl.innerHTML = html;
    }

    // Newsletter-Formular: starte Polling
    setTimeout(addNewsletterClass, 2000);
  });
})();

// Endless Scroll initialisieren
document.addEventListener("DOMContentLoaded", function() {
  var endlessScroll = new Ajaxinate();
});
